export const dynamic_text_convert = ({ main_text, value, check_by }) => {
  if (main_text) {
    const regex = new RegExp(check_by, 'g'); // 'g' flag for global replacement
    return main_text.replace(regex, value);
  }
  return main_text; // Return unchanged if main_text is empty
};
